// import { CanActivateFn } from '@angular/router';

// export const authGuard: CanActivateFn = (route, state) => {
//   return true;
// };


import { Injectable } from '@angular/core';
import { Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { UserService } from './services/user.service';

// import { UserService } from '../services/user.service';

@Injectable({ providedIn: 'root' })
export class AuthGuard {
    constructor(
        private router: Router,
        private authenticationService: UserService
    ) { }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        const user = this.authenticationService.getUserValue();
        // const user = true
        if (user) {
            // logged in so return true
            return true;
        } else {

        // not logged in so redirect to login page with the return url
        this.router.navigate([`/${state.url}`]);
        return false;
        }
    }
}